module.exports = __webpack_public_path__ + "img/id.c31620a8.png";